import React from "react";
import Aux from "../../../hoc/Auxilliary";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid } from "@material-ui/core/";

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classHeaderFont: {
    fontSize: "1.1rem",
    fontWeight: 800,
    flex: 1,
  },
  classContentFont: {
    fontSize: "1rem",
    flex: 1,
  },
});

const ApplicationFirstPage = (props) => {
  const classes = useStyles(props);
  return (
    <Aux>
      <Grid>
        <Grid className={classes.classConatiner}>
          <Typography component="div" className={classes.classHeaderFont}>
            Avant de commencer, je confirme :
          </Typography>
          <Typography component="div" className={classes.classFont}>
            • avoir pris connaissance des étapes du processus d’admission sous
            l’onglet « Admissions » du site Web de l’USB et des critères
            d’admission du programme qui m’intéresse;
          </Typography>
          <Typography
            component="div"
            className={classes.classContentFont}
            style={{ lineHeight: "2rem" }}
          >
            • avoir lu et compris tous les renseignements {" "} à la page { " "}
           <a href="https://ustboniface.ca/permis-etude" target="_blank">Permis d'études</a>
            {" "}
            (population internationale seulement);
          </Typography>
          <Typography
            component="div"
            className={classes.classContentFont}
            style={{ lineHeight: "2rem" }}
          >
            • comprendre que les frais de traitement de dossier sont non
            remboursables et sont payables par carte Visa ou Mastercard (crédit
            ou débit). Il faut effectué le paiement avant de soumettre la
            demande d’admission.
          </Typography>
        </Grid>
        <Typography component="div" className={classes.classHeaderFont}>
          Pour la population internationale qui ne suit pas de cours à l’USB
          présentement :
        </Typography>
        <Grid>
          <Typography component="div" className={classes.classContentFont}>
            • Je comprends que je dois soumettre des résultats d’un test
            normalisé en français. Ce test est obligatoire, même si je suis d’un
            pays francophone et que j’ai suivi mes études en français. Les
            résultats doivent être reçus avant que l’USB entame l’évaluation du
            dossier d’admission. Il n’est malheureusement pas possible
            d’effectuer le test de français une fois à l’USB.*
          </Typography>
          <Typography component="div" className={classes.classContentFont}>
            • Je comprends qu’il est possible que j’aie besoin d’une lettre
            d’attestation provinciale (LAP) pour déposer une demande de permis
            d’études auprès d’Immigration, Réfugiées et Citoyenneté Canada
            (IRCC). Si je reçois une offre d’admission conditionnelle ou
            officielle, l’USB exigera un dépôt pour signaler mon engagement
            envers le processus de ma poursuite d’études à l’USB. Ce dépôt, un
            minimum de 3 000 $ CAN, est un paiement à l’avance de mes frais de
            scolarité, et sera appliqué envers ma première session d’études. Le
            dépôt n’est pas remboursable, sauf dans le cas d’un refus de la
            demande de permis d’études, auquel cas il sera remboursé moyennant
            des frais de traitement de 300 $.
          </Typography>
        </Grid>

        <>
          <Grid className={classes.classConatiner}>
            <Typography component="div" className={classes.classContentFont}>
              * À noter que l’USB n’exige pas de résultats d’un test normalisé
              en français pour les programmes suivants : certificat de
              traduction, baccalauréat ès arts spécialisé en traduction et
              baccalauréat en éducation, car une évaluation langagière
              spécifique au programme est déjà prévue dans le cadre de la
              demande d’admission. De plus amples renseignements te seront
              communiqués dans l’état de la demande d’admission une fois
              soumise.
            </Typography>
          </Grid>
          <Grid className={classes.classConatiner}>
            <Typography component="div" className={classes.classHeaderFont}>
              Pour les membres de la population étudiante présentement inscrits
              au programme Université 1 à l’USB:
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ marginTop: "1rem" }}
            >
              Je comprends que je peux choisir de poursuivre mes études au
              baccalauréat ès sciences général ou au baccalauréat ès arts
              général lors de ma prochaine inscription aux cours et qu’une
              nouvelle demande d’admission <u> n’est pas requise</u> pour ces
              deux programmes. Une demande d’admission est toutefois requise
              pour changer à n’importe quel autre programme.
            </Typography>
          </Grid>
        </>
      </Grid>
    </Aux>
  );
};

export default ApplicationFirstPage;
